export default __webpack_public_path__ + "0b6ba4f36b7c7521e7e83e7b36c528e7.jpg";